import React from 'react'
import classes from './ErrorLogin.module.css'

function ErrorLogin() {
    return (
        <div className={classes.error}>
            <h2>Please log in to upload images</h2>
        </div>
    )
}

export default ErrorLogin;
